/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Spinner } from 'sarsaparilla';
import { availabilityActions } from '../actions';
import { availabilitySelectors } from '../reducers';
import permitShape from '../utils/permitShape';
import PreferredDatesList from '../components/lottery-registration/PreferredDatesList';

export class LotteryAvailabilityContainer extends Component {
    static propTypes = {
        permit: permitShape.isRequired,
        validation: PropTypes.shape({}),
        fetchAvailability: PropTypes.func,
        seasonStart: PropTypes.string,
        seasonEnd: PropTypes.string,
        seasonYear: PropTypes.number,
        permitType: PropTypes.string,
    };

    constructor(props) {
        super(props);
        this.state = {
            display: false,
        };
    }

    componentDidMount() {
        this.fetchAvailability();
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.seasonStart !== prevProps.seasonStart ||
            this.props.seasonEnd !== prevProps.seasonEnd ||
            this.props.permitType !== prevProps.permitType
        ) {
            this.fetchAvailability();
        }
    }

    fetchAvailability = () => {
        const {
            permit,
            fetchAvailability,
            seasonStart,
            seasonEnd,
            seasonYear,
            permitType,
        } = this.props;
        if (seasonStart && seasonEnd && permitType) {
            this.setState({ display: false });
            fetchAvailability({
                permitId: permit.id,
                type: permitType,
                year: seasonYear,
            }).finally(() => this.setState({ display: true }));
        }
    };

    render() {
        if (this.state.display) {
            return <PreferredDatesList {...this.props} />;
        }
        return (
            <div className="per-preferred-dates-list">
                <Spinner />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        availability: availabilitySelectors.getAvailability(state),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchAvailability: bindActionCreators(
            availabilityActions.fetchAvailability,
            dispatch
        ),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LotteryAvailabilityContainer);
